(function () {

    'use strict';

    class AetDialogCtrl {
        constructor($mdDialog, dcmService) {
            this.dialog = $mdDialog;
            this.service = dcmService;
        }

        static get $inject() {
            return ["$mdDialog", "dcmService"];
        }

        $onInit() {
            this.aet = this.aet ? this.aet : {};
        }

        cancel() {
            this.dialog.cancel();
        }

        submit() {
            this.service.handleAet(this.aet)
                .then(data => this.dialog.hide(data));
        }
    }

    module.exports = {
        multiple: true,
        controllerAs: "vm",
        bindToController: true,
        parent: $(document.body),
        clickOutsideToClose: true,
        controller: AetDialogCtrl,
        template: require("./aet-dialog.tpl.html"),
    };

})();
